import DeleteIcon from '@/assets/icons/DeleteIcon';
import IndeterminateCheckBoxOutlined from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import { IconButton, Stack, SxProps, Typography } from '@mui/material';
import { useCallback } from 'react';
import { DeleteConfirmDialog } from './ConfirmDialog';
import { useDialog } from '@/modules/common/hooks';
import { useTranslation } from 'react-i18next';

const iconAction = {
    color: 'neutral.dark',
    borderRadius: 0,
    '&:active, &:hover, &.active': {
        color: 'primary.main',
    },
};

type Props = {
  nrOfSelectedSimulations: number;
  sx: SxProps;
  onSelectAll: () => void;
  onDeleteSelected: () => void;
};

function SelectedItemsInfo({ nrOfSelectedSimulations, sx, onSelectAll, onDeleteSelected }: Props) {
  const { t } = useTranslation('interface');
  const { open: deleteDialogOpen, setOpen: toggleDeleteDialog } = useDialog();

  const onDeleteSelectedSimulationClick = useCallback(
    () => toggleDeleteDialog(true),
    [toggleDeleteDialog],
  );

  const onDeleteConfirm = useCallback(() => onDeleteSelected(), [onDeleteSelected]);

  return (
    <>
      {nrOfSelectedSimulations > 0 && (
        <Stack direction='row' gap={1} justifyContent='space-between' sx={sx}>
          <Stack direction='row' alignItems='center'>
            <IconButton onClick={onSelectAll} sx={iconAction}>
              <IndeterminateCheckBoxOutlined />
            </IconButton>
            <Typography align='left' variant='h4'>
              {nrOfSelectedSimulations} selected
            </Typography>
          </Stack>
          <IconButton sx={iconAction} onClick={onDeleteSelectedSimulationClick}>
            <DeleteIcon />
          </IconButton>
        </Stack>
      )}
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        runName={t('simulation.simulation_list.header')}
        confirmation={t('simulation.delete_dialog.confirmation')}
        onConfirm={() => {
          onDeleteConfirm();
          toggleDeleteDialog(false);
        }}
        onCancel={() => toggleDeleteDialog(false)}
      />
    </>
  );
}

export default SelectedItemsInfo;